import { LineItemPayload } from '~/types/LineItem';
import { ActionKeys } from './constants';
import { TrackingReference } from '~/utils/TrackingHelper/types';

export function createLineItem(
  orderObjectId: string,
  lineItemPayload: LineItemPayload,
  trackingReference: TrackingReference,
) {
  return <const>{
    type: ActionKeys.LINE_ITEM_CREATE,
    payload: {
      orderObjectId,
      lineItemPayload,
      trackingReference,
    },
  };
}

export function createLineItemSuccess() {
  return <const>{
    type: ActionKeys.LINE_ITEM_CREATE_SUCCESS,
  };
}

export function createLineItemError() {
  return <const>{
    type: ActionKeys.LINE_ITEM_CREATE_ERROR,
  };
}

export function deleteLineItem(
  id: string,
  orderObjectId: string,
  trackingReference: TrackingReference,
) {
  return <const>{
    payload: { id, orderObjectId, trackingReference },
    type: ActionKeys.LINE_ITEMS_DELETE,
  };
}

export function deleteLineItemSuccess() {
  return <const>{
    type: ActionKeys.LINE_ITEMS_DELETE_SUCCESS,
  };
}

export function deleteLineItemError() {
  return <const>{
    type: ActionKeys.LINE_ITEMS_DELETE_ERROR,
  };
}

export function editLineItem(
  lineItemObjectId: string,
  orderObjectId: string,
  lineItemPayload: LineItemPayload,
  trackingReference: TrackingReference,
) {
  return <const>{
    payload: { lineItemObjectId, orderObjectId, lineItemPayload, trackingReference },
    type: ActionKeys.LINE_ITEM_EDIT,
  };
}

export function editLineItemSuccess() {
  return <const>{
    type: ActionKeys.LINE_ITEM_EDIT_SUCCESS,
  };
}

export function editLineItemError() {
  return <const>{
    type: ActionKeys.LINE_ITEM_EDIT_ERROR,
  };
}

export type LineItemActions =
  | ReturnType<typeof createLineItem>
  | ReturnType<typeof createLineItemSuccess>
  | ReturnType<typeof createLineItemError>
  | ReturnType<typeof deleteLineItem>
  | ReturnType<typeof deleteLineItemSuccess>
  | ReturnType<typeof deleteLineItemError>
  | ReturnType<typeof editLineItem>
  | ReturnType<typeof editLineItemSuccess>
  | ReturnType<typeof editLineItemError>;
